// extracted by mini-css-extract-plugin
module.exports = {"description":"c6e8ba5398--description--2yXI4"};